import { Work } from "@/interfaces/work";

const works: Work[] = [
  {
    id: "vankwallet",
    title: "VankWallet",
    info: "Vank enables underserved demographics crowd-buy real estate, form real estate cooperatives, and manage their holdings using Vank's blockchain integrated wallet system and SAAS infrastructure.",
    article: [
      "Vank enables underserved demographics crowd-buy real estate, form real estate cooperatives, and manage their holdings using Vank's blockchain integrated wallet system and SAAS infrastructure.",
    ],
    paragraphs: [
      "The application aims to offer a user-friendly interface with robust security measures, allowing users to seamlessly perform transactions, monitor their holdings, and access essential financial tools",
      "The frontend of the application was developed with modern frontend technologies including VueJS, NuxtJS, and Material UI, ensuring a consistent user experience across various devices, including desktops, tablets, and mobile phones. The backend infrastructure was developed with Laravel, a PHP framework. RESTful APIs were used for integrating data transfer and commnunication between the frontend and the backend. It works on a secure and scalable relational database system to ensure storage and management of data, using SQL for storind processsing of informrmation.",
      "Vank Wallet integrates with various cryptocurrency APIs to support seamless deposits, withdrawals, and exchange functionalities.",
    ],
    banner: "banner.png",
    height: 828,
    width: 8320,
    pages: [
      {
        src: "page1.png",
        alt: "Landing page",
        caption: "Landing page",
      },
      {
        src: "page2.png",
        alt: "About page",
        caption: "About vankwallet",
      },
      {
        src: "page3.png",
        alt: "Dashoard properties view",
        caption: "User dashboard page",
      },
      {
        src: "mobile.png",
        alt: "Mobile view of buy real estate page",
        caption: "Mobile view of buy real estate page",
      },
      {
        src: "page4.png",
        alt: "Asset details view",
        caption: "Asset details view",
      },
      {
        src: "page5.png",
        alt: "Buy an installment asset view",
        caption: "Buy an installment asset view",
      },
    ],
    tags: ["Corporate Work", "VueJs", "NuxtJS", "REST", "Laravel"],
    live: "vankwallet.com",
    github: "",
  },
  {
    id: "wgh-reseller-site",
    title: "Whogohost Reseller Center",
    info: "Unique, dynamic, reseller site auto generated for individual resellers of Whogohost, a web hosting company. Website's data is auto generated according to the reseller's domain.",
    article: [
      "Unique, dynamic, reseller site auto generated for individual resellers of Whogohost, a web hosting company. Website's data is auto generated according to the reseller's domain.",
      "Users are able to search for a domain name, register a domain name, and manage their domains on the clientarea. They can also manage their hosting accounts, and view (and download) their invoices. Buil with ReactJS, Redux and RESTAPIs. Payment integration was done using Paystack and Flutterwave.",
    ],
    paragraphs: [
      "Unique, dynamic, reseller site auto generated for individual resellers of Whogohost, a web hosting company. Website's data is auto generated according to the reseller's domain.",
      "Users are able to search for a domain name, register a domain name, and manage their domains on the clientarea. They can also manage their hosting accounts, and view (and download) their invoices. Buil with ReactJS, Redux and RESTAPIs. Payment integration was done using Paystack and Flutterwave.",
    ],
    banner: "banner.png",
    width: 8320,
    height: 828,
    pages: [
      {
        src: "page1.png",
        alt: "Landing page",
        caption: "Landing page",
      },
      {
        src: "page2.png",
        alt: "Services preview on landing page",
        caption: "Services preview on landing page",
      },
      {
        src: "page3.png",
        alt: "Domain search page",
        caption: "Search a domain's availability",
      },
      {
        src: "page4.png",
        alt: "Mobile view of domain transfer page",
        caption: "Transfer an existing domain to Whogohost",
      },
      {
        src: "page5.png",
        alt: "Dashboard page",
        caption: "Client dashboard",
      },
      {
        src: "page6.png",
        alt: "Hosting plans page",
        caption: "View hosting plans",
      },
    ],
    tags: [
      "Corporate Work",
      "ReactJS",
      "Redux",
      "Paystack",
      "Flutterwave",
      "Domains",
    ],
    live: "whogohost.myreseller.site",
    github: "",
  },
  {
    id: "resell-wgh",
    title: "Whogohost Reseller Landing Page",
    info: "Beautiful, aesthetic, fully responsive landing page for Whogohost resellers, capturing brand identitiy and elegance.",
    article: [
      "Beautiful, aesthetic, fully responsive landing page for Whogohost resellers, capturing brand identitiy and elegance.",
      "Developed with HTML, CSS, JavaScript and jquery.",
    ],
    paragraphs: [
      "Beautiful, aesthetic, fully responsive landing page for Whogohost resellers, capturing brand identitiy and elegance.",
      "Developed with HTML, CSS, JavaScript and jquery.",
    ],
    banner: "banner.png",
    width: 5162,
    height: 828,
    pages: [
      {
        src: "page1.png",
        alt: "Hero section",
        caption: "Hero section",
      },
      {
        src: "page2.png",
        alt: "Why choose us",
        caption: "Features section",
      },
      {
        src: "page3.png",
        alt: "who are we (mobile)",
        caption: "Mobile view of about section",
      },
      {
        src: "page4.png",
        alt: "who are we",
        caption: "About section",
      },
    ],
    tags: ["Corporate Work", "HTML", "CSS", "Javscript", "jquery"],
    live: "resell.whoghost.com",
    github: "",
  },
  {
    id: "tnnafrica",
    title: "TNNAfrica",
    info: "Doctor-Patient health care web application. It includes document sharing, appointment booking, and video call sessions.",
    article: [
      "Doctor-Patient health care web application for TNNAfrica. It includes document sharing, appointment booking, and video call sessions.",
    ],
    paragraphs: [
      "TNN Africa is a web based software application aimed at improving the Nutrition Value chain in Africa. It improves Doctor-Patient communitcation with features including in-app document sharing, appointment booking, and in-app video call sessions.",
      "The frontend of the application was built with frontend technologies including ReactJS, Redux, and TailwindCSS. The backend infrastructure was developed with NodeJS. REST APIs were used for data transfer and commnunication between the frontend and the backend. In-app video call feature was integrated using WebRTC",
    ],
    banner: "banner.png",
    height: 903,
    width: 6723,
    pages: [
      {
        src: "page1.png",
        alt: "Landing page",
        caption: "Landing page",
      },
      {
        src: "page2.png",
        alt: "Appointment feature",
        caption: "Book an appointment with a doctor",
      },
      {
        src: "page3.png",
        alt: "Contact page",
        caption: "Contact Us page",
      },
      {
        src: "page4.png",
        alt: "Mobile view of contact page",
        caption: "Mobile view of contact page",
      },
      {
        src: "page5.png",
        alt: "Speak to us page",
        caption: "Speak to us page",
      },
    ],
    tags: ["Corporate Work", "ReactJS", "Redux", "RESTAPI", "WebRTC"],
    live: "tnnafrica.com/",
    github: "",
  },
  {
    id: "cv-builder",
    title: "CV Builder",
    info: "A simple CV builder web app built with ReactJs and Firebase. It allows users to create a CV quickly by filling a set of forms. Users can save their progress and continue creating their CV later.",
    article: [
      "A simple CV builder web app built with ReactJs and Firebase. It allows users to create a CV quickly by filling a set of forms. Users can save their progress and continue creating their CV later.",
      " Users can preview CV while creating it and download it as a PDF file. They can also edit a CV after building it.",
    ],
    banner: "banner.png",
    height: 825,
    width: 5146,
    paragraphs: [
      "CV Builder is a web-based application that allows users to create and customize their own professional CV or resume. The application is built using modern web technologies such as ReactJS, Firebase, and Cloud Firestore.",
      "It offers a range of features and tools for creating and customizing professional CVs or resumes.",
      "The front-end of the application is designed using a responsive layout, with a clean and modern user interface that is easy to navigate. The application features a number of sections including personal information, work experience, education, skills, and more. Users can easily add and edit sections as needed, and preview their CV in real-time.",
      "Upon completion of all forms a downloadable PDF document of the user's CV is created.",
      "In terms of security, the application employs a number of measures to protect user data and prevent unauthorized access. This includes the use of Firebase authentication to secure user accounts, and SSL encryption to secure all data transmitted between the user's device and the application server.",
    ],
    pages: [
      {
        src: "page1.png",
        alt: "Landing page",
        caption: "Landing page",
      },
      {
        src: "page2.png",
        alt: "Login page",
        caption:
          "Login page, where users login with existing account or create a new one",
      },
      {
        src: "page3.png",
        alt: "Personal info page",
        caption: "Personal info form page",
      },
      {
        src: "page4.png",
        alt: "Work experience page on mobile",
        caption: "Mobile view of work experience form page",
      },
    ],
    tags: ["Personal Project", "ReactJs", "Redux", "Firebase"],
    live: "cv-builder-c0429.web.app",
    github: "github.com/Joblyn/Cv-Builder",
  },
  {
    id: "netflix",
    title: "Netflix Clone",
    info: "A clone of netflix official web app, built with ReactJS, Firebase, and GSAP library. A user is able to authenticate into his account, view a catalogue of movies and series and watch a simple video.",
    article: [
      "A clone of netflix official web app, built with ReactJS, Firebase, and GSAP library. A user is able to authenticate into his account, view a catalogue of movies and series and watch a simple video.",
      "It was built with React Context API, Redux state management library, and Firestore database.",
    ],
    paragraphs: [
      "Netflix Clone is a web-based application that replicates the look and functionality of the popular streaming platform, Netflix. The application is built using modern web technologies such as ReactJS, Firebase, and Cloud Firestore",
      "The front-end of the application is designed using a responsive layout, with a user interface that closely resembles the Netflix interface. The application features a range of features and tools, including the ability to browse and search for movies and TV shows, view trailers, and add items to a watchlist.",
      "It integrates with Firestore for data storage and management, and alos Firebase Auth for user authentication and access to app features.",
    ],
    banner: "banner.png",
    height: 833,
    width: 6723,
    pages: [
      {
        src: "page1.png",
        alt: "Landing page",
        caption: "Landing page",
      },
      {
        src: "page2.png",
        alt: "Login page",
        caption: "Login page, where user login or create a new one",
      },
      {
        src: "page3.png",
        alt: "Select user page",
        caption: "Select the user's profile to watch in",
      },
      {
        src: "page4.png",
        alt: "Mobile view of movies page",
        caption: "Mobile view of movies page",
      },
      {
        src: "page5.png",
        alt: "Preview movie info",
        caption: "Read about a movie before watching",
      },
    ],
    tags: ["Personal Project", "ReactJS", "Firebase"],
    live: "netflix-clone-40b11.web.app/",
    github: "github.com/Joblyn/Netflix-clone",
  },
  {
    id: "exowem",
    title: "Exowem",
    info: "Web application for trading bitcoin and giftcards, built with ReactJS.",
    article: [
      "Beautiful, aesthetic web application for trading of bitcoin and gitcards, with selective dark theme.",
      "Developed with TailwindCSS and ReactJS.",
    ],
    paragraphs: [
      "Beautiful, aesthetic web application for trading of bitcoin and gitcards, with selective dark theme.",
      "Developed with TailwindCSS and ReactJS.",
    ],
    banner: "banner.png",
    width: 7192,
    height: 828,
    pages: [
      {
        src: "page1.png",
        alt: "Landing page",
        caption: "Landing page",
      },
      {
        src: "page2.png",
        alt: "landing page night mode (mobile)",
        caption: "Mobile view of landing page in dark theme",
      },
      {
        src: "page3.png",
        alt: "dashboard",
        caption: "User dashboard showing approximate bitcoing balance.",
      },
      {
        src: "page4.png",
        alt: "user offers in night mode",
        caption: "User's offers in night mode",
      },
      {
        src: "page5.png",
        alt: "user offers in night mode (mobile)",
        caption: "Mobile view of user's  offers in night mode",
      },
      {
        src: "page6.png",
        alt: "user giftcards in night mode",
        caption: "User's giftcards in night mode",
      },
    ],
    tags: ["Personal Project", "ReactJS", "Redux", "RESTAPI"],
    live: "exowem-e932d.web.app",
    github: "github.com/Joblyn/Exowem",
  },
];

export default works;
